import * as React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { Empty, Spin } from 'antd';
import { getPublicReport } from './api';
import ReportBody from './ReportBody';

/** Standalone social metrics report. No app navigation. */
const PublicSocialMetricsPage: React.FC = () => {
    const { token } = useParams<{ token: string }>();
    const { data, isLoading, isError } = useQuery({
        queryKey: ['social-metrics-public', token],
        queryFn: () => getPublicReport(token!),
        enabled: !!token,
    });

    return (
        <div className="force-light" style={{ maxWidth: 1200, margin: '0 auto', padding: 24, background: '#fff', minHeight: '100vh' }}>
            {isLoading ? <div style={{ padding: 48, textAlign: 'center' }}><Spin /></div> : null}
            {!isLoading && (isError || !data?.snapshot) ? <Empty description="Report not found" /> : null}
            {data?.snapshot ? <ReportBody report={data.snapshot} /> : null}
        </div>
    );
};

export default PublicSocialMetricsPage;
